export default {
  app: {
    tradeOffers: {
      country: 'Paese',
      loginPrompt: 'Per vedere le offerte B2B devi {0}.',
      logIn: 'login',
    },
  },
};
